// extracted by mini-css-extract-plugin
export default {"tablesContainer":"EquivalenceTablePage_tablesContainer__NCGyN"};